<template>
  <div>
    <vx-card class="my-4">
      <div class="vx-row">
        <div class="vx-col w-full mb-4 sm:w-1/4 sm:mb-0">
          <v-select
            :disabled="disableSiteSelect || disableSearch"
            label="name"
            placeholder="Select site"
            class="w-full"
            v-model="site"
            :options="siteLists"
          ></v-select>
        </div>
        <div class="vx-col w-full mb-4 sm:w-1/4 sm:mb-0">
          <v-select
            label="eventName"
            placeholder="Select event"
            class="w-full"
            v-model="event"
            :options="eventLists"
          ></v-select>
        </div>

        <div class="vx-col w-full mb-4 sm:w-1/4 sm:mb-0">
          <date-picker
            placeholder="Select datetime range"
            v-model="daterange"
            type="datetime"
            range
            format="DD/MM/YYYY HH:mm"
          ></date-picker>
        </div>

        <div class="vx-col">
          <vs-button
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            @click.prevent="searchData"
            :disabled="!event || !site"
            >Search</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card v-if="lists.length > 0">
      <vs-table stripe :data="lists">
        <template slot="thead">
          <vs-th>No</vs-th>
          <vs-th class="text-left">Camera Name</vs-th>
          <vs-th class="text-left">Site Name</vs-th>
          <vs-th class="text-left">Alarm Date</vs-th>
          <vs-th class="text-left">Event</vs-th>
          <vs-th class="text-right">&nbsp;</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="indextr">
              {{ indextr + 1 }}
            </vs-td>

            <vs-td class="text-left" :data="tr.cameraName">
              {{ tr.cameraName }}
            </vs-td>

            <vs-td class="text-left" :data="tr.siteName">
              {{ tr.siteName }}
            </vs-td>

            <vs-td class="text-left" :data="tr.time">
              {{ parseDate(tr.time) }}
            </vs-td>

            <vs-td class="text-left" :data="tr.parameterEventName">
              {{ tr.parameterEventName }}
            </vs-td>

            <vs-td class="text-right">
              <div class="flex justify-end">
                <vs-tooltip text="Detail">
                  <!-- <router-link :to="`/alarm/${tr.id}`"> -->
                  <router-link :to="`/alarm/${tr.id}`">
                    <feather-icon icon="ChevronRightIcon" svgClasses="icon" />
                  </router-link>
                </vs-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <vx-card v-else-if="isLoading">
      <div class="flex flex-col items-center text-center">
        <vs-spinner />
        <h3>Loading...</h3>
      </div>
    </vx-card>
    <vx-card v-else-if="dataUnavailable">
      <div class="flex flex-col items-center text-center">
        <h3>Data is not available</h3>
      </div>
    </vx-card>
    <vx-card v-else>
      <div class="flex flex-col items-center text-center">
        <img style="width: 300px" src="@/assets/images/icon/icon-grafik.png" />
        <h3>Silahkan pilih event untuk menampilkan data</h3>
      </div>
    </vx-card>
  </div>
</template>

<script>
import moment from "moment";
import vSelect from "vue-select";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import api from "@/api";

export default {
  data() {
    return {
      disabledDates: {
        from: new Date(),
      },
      isLoading: false,
      dataUnavailable: false,
      daterange: "",
      event: "",
      eventLists: [],
      site: "",
      siteLists: [],
      lists: [],
      searchParams: {},
    };
  },
  components: {
    DatePicker,
    vSelect,
  },
  mounted() {
    this.getSiteLists();
    this.getEventLists();
  },
  methods: {
    getSiteLists() {
      if (this.$store.state.sites.length > 0) {
        this.siteLists = this.$store.state.sites;
        this.disableSiteSelect = this.siteLists.length <= 1;
        if (this.siteLists.length === 1) {
          this.site = this.siteLists[0];
        }
      } else {
        this.$vs.loading();
        api
          .sites({
            siteName: this.searchQuery,
          })
          .then((result) => result.data)
          .then((data) => {
            if (data.status) {
              this.siteLists = data.data;
              this.$store.dispatch("updateSiteLists", data.data);
              this.disableSiteSelect = this.siteLists.length <= 1;
              if (this.siteLists.length === 1) {
                this.site = this.siteLists[0];
              }
            }
            this.$vs.loading.close();
          })
          .catch((e) => {
            console.log(e);
            this.$vs.loading.close();
          });
      }
    },
    searchData() {
      this.searchParams = {
        stardate: this.daterange[0],
        enddate: this.daterange[1],
        parameterEventId: this.event.id,
        siteId: this.site.id,
      };

      this.getLists();
    },
    getLists() {
      this.isLoading = true;

      api
        .getAlarmLists(this.searchParams)
        .then((result) => result.data)
        .then((data) => {
          if (data.status) {
            this.lists = data.data;
            this.dataUnavailable = this.lists.length === 0;
          } else {
            this.dataUnavailable = true;
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getEventLists() {
      if (this.$store.state.events.length > 0) {
        this.eventLists = this.$store.state.events;
      } else {
        this.$vs.loading();
        api
          .getEventLists()
          .then((result) => result.data)
          .then((data) => {
            if (data.status) {
              this.eventLists = data.data;
              this.$store.dispatch("updateEventLists", data.data);
            }
            this.$vs.loading.close();
          })
          .catch((e) => {
            console.log(e);
            this.$vs.loading.close();
          });
      }
    },
    parseDate(dateString) {
      return moment(dateString).format("DD MMM YYYY hh:mm");
    },
  },
};
</script>
